<template>
  <div>
    <div class="head_box flex_start flex_center_align">
      <svg-icon icon-class="edit_2_line"></svg-icon>
      <span class="hd_title">
        <slot name="hd_title">報告書一覧</slot>
      </span>
    </div>
    <div class="h_date flex_center_align">
      <svg-icon icon-class="tryangle_down" class="h_svg"></svg-icon>
      <span class="h_title h_img_none">
        <slot name="h_title">書類の提出を行ってください</slot>
      </span>
    </div>
    <div v-for="(row, index) in fileList" :key="index" class="file_box_new">
      <div class="header_box flex_start flex_center_align">
        <span class="title">
          {{ $baseLodash.replace(row.docName, '原価見積書', '見積書') }}
          <i v-if="checkEnumFlag(row.requiredFlg)" class="red">*</i>
        </span>
        <vab-upload
          v-if="row.uploadCheck"
          :upload-url="row.uploadUrl"
          :params-data="row"
          @on-success="successFile"
        ></vab-upload>
        <span v-if="row.docName == '少量廃棄物運搬指示書'" class="hint_txt_red">
          ※ 原本をご郵送にてご提出ください
        </span>
      </div>
      <div
        class="file_item_box"
        :class="{ flex_space: row.list && row.list.length > 1 }"
      >
        <div
          v-for="(item, cIndex) in row.list"
          :key="cIndex"
          :class="{ more_colum: row.list.length > 1 }"
          class="file_item"
        >
          <div class="file_item_ne flex_colum">
            <div class="company flex_start flex_center_align">
              <svg-icon icon-class="user_4_fill" class="user"></svg-icon>
              <div class="name">{{ item.company }}</div>
              <template
                v-if="item.showStateList && item.showStateList.length > 0"
              >
                <div
                  v-for="(state, sIndex) in item.showStateList"
                  :key="sIndex"
                  class="state_box flex_start flex_center_align"
                  :style="{
                    backgroundColor: state.bg,
                    color: state.color,
                    borderColor: state.borderColor,
                  }"
                >
                  <svg-icon
                    :icon-class="state.icon"
                    class="check_icon"
                  ></svg-icon>
                  <div class="mark">{{ state.docSubmitStatusName }}</div>
                </div>
              </template>
            </div>
            <div
              v-for="(file, f) in item.fileList"
              :key="f"
              class="file_inner_item flex_start pl0"
            >
              <div class="arrow_box">
                <svg-icon icon-class="tryangle_right" class="arrow"></svg-icon>
              </div>
              <div class="flex_colum file_name_box">
                <span class="file_name" @click="downLoad(row, file)">
                  {{ file.fileName }}
                </span>
                <div class="file_time">
                  アップロード日時：{{ file.createDate }}
                  {{ formatTimeMsel(file.createTime) }}
                </div>
                <svg-icon
                  v-if="deleteShow(file)"
                  icon-class="close_circle_fill"
                  class="del"
                  @click="deleteFile(row, file, item, f)"
                ></svg-icon>
              </div>
            </div>
          </div>
          <template v-if="item.dlnBtnList && item.dlnBtnList.length > 0">
            <div class="btn_box_file flex_start flex_center_align">
              <div
                v-for="(btn, d) in item.dlnBtnList"
                :key="d"
                class="state_box flex_start flex_center_align"
                :class="[btn.check ? btn.checkClassName : '']"
                @click="handleBtn(btn)"
              >
                <template v-if="btn.type == 'button'">
                  <svg-icon
                    :icon-class="btn.icon"
                    class="check_icon"
                  ></svg-icon>
                  <div class="mark">{{ btn.name }}</div>
                </template>
                <template v-else-if="btn.type == 'checkbox'">
                  <el-checkbox v-model="btn.check">{{ btn.name }}</el-checkbox>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="bs_btn_main m12 new_btn_icon">
      <vab-button :btn-list="btnList"></vab-button>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  export default {
    name: 'VabFile',
    props: {
      nofile: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        fileList: [],
        paramsData: {},
        btnList: [
          {
            name: '報告書サンプル',
            icon: 'down',
            type: 'plain',
            widht: 'auto',
            hover: '#0171EE',
            disabled: true,
            hidden: false,
            defaultColor: '#0060C2',
            click: () => {
              this.downloadFile()
            },
          },
          {
            name: '全ファイル一括ダウンロード',
            icon: 'down',
            type: 'plain',
            widht: 'auto',
            hover: '#0171EE',
            hidden: true,
            defaultColor: '#0060C2',
            click: () => {
              this.downloadFileAll()
            },
          },
        ],
      }
    },
    computed: {
      deleteShow() {
        return (file) => {
          return file.delCheck && this.delSvgShow(file.reportSubmitStatus)
        }
      },
    },
    mounted() {},
    methods: {
      initData(data, showTemp) {
        this.paramsData = data
        if (
          this.isEqualCodeEnum(
            this.paramsData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          ) &&
          this.isEqualCodeEnum(
            this.paramsData.fileType.value,
            this.$divisions.bookTypeEnum.document
          )
        ) {
          this.btnList[0].hidden = true
        }
        this.btnList[1].hidden = !showTemp
      },
      // 報告書サンプル
      async downloadFile() {
        let data = {
          ...this.paramsData,
        }
        let url = ''
        if (
          this.isEqualCodeEnum(
            this.paramsData.fileType.value,
            this.$divisions.bookTypeEnum.report
          ) &&
          this.isEqualCodeEnum(
            this.paramsData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          )
        ) {
          url = '/api/scReport/downloadSample'
        }
        this.downloadCommon.resource(url, data, null)
      },
      // 全ファイル一括ダウンロード
      async downloadFileAll() {
        let data = {
          ...this.paramsData,
        }
        if (
          this.isEqualCodeEnum(
            this.paramsData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          )
        ) {
          data.adjSourceClass = this.$divisions.adjSourceClassEnum.enum_1.value
        } else {
          data.adjSourceClass = this.$divisions.adjSourceClassEnum.enum_2.value
        }
        let url = ''
        if (
          this.isEqualCodeEnum(
            this.paramsData.fileType.value,
            this.$divisions.bookTypeEnum.document
          ) &&
          this.isEqualCodeEnum(
            this.paramsData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          )
        ) {
          url = '/api/requestDocuments/downloadAll'
        } else if (
          this.isEqualCodeEnum(
            this.paramsData.fileType.value,
            this.$divisions.bookTypeEnum.report
          ) &&
          this.isEqualCodeEnum(
            this.paramsData.roleType.value,
            this.$divisions.notifyTypeEnum.work
          )
        ) {
          url = '/api/scReport/downloadAll'
        }
        this.downloadCommon.zip(url, data)
      },
      // ファイルリストを設定する
      setList(list, vm) {
        list.filter((item) => {
          item.operationType = this.$divisions.operationTypeEnum.enum_U.value
        })
        this.fileList = list
        this.vm = vm
      },
      delSvgShow(reportSubmitStatus = null) {
        let reportSubmitStatusList = [
          this.$divisions.docSubmitStatusEnum.enum_7.value,
          this.$divisions.docSubmitStatusEnum.enum_8.value,
        ]
        if (reportSubmitStatusList.includes(reportSubmitStatus)) {
          return false
        } else {
          return true
        }
      },
      // アップロード成功コールバック
      successFile(res) {
        if (this?.vm?.reloadBook) {
          this.vm.reloadBook()
        } else {
          res.operationType = this.$divisions.operationTypeEnum.enum_I.value
          this.vm.initList.push(res)
          this.vm.realFileList.push(res)
          this.vm.setFileList(true)
        }
      },
      // 報告書ダウンロード
      async downLoad(row, file) {
        let data = {
          implementStatusId: row.implementStatusId,
          purchaseOrderBaseId: row.purchaseOrderBaseId,
          buildingCd: row.buildingCd,
          acceptOrderKey: row.acceptOrderKey,
          docName: row.docName,
          docId: row.docId,
          reportId: file.reportId,
          reqDocId: file?.reqDocId,
          fileName: file?.fileName,
          requestDetailId: row?.requestDetailId,
        }
        this.downloadCommon.resource(row.downLoadUrl, data)
      },
      async submitDelFile(row, file, item, index) {
        let data = {
          implementStatusId: row.implementStatusId,
          purchaseOrderBaseId: row.purchaseOrderBaseId,
          buildingCd: row.buildingCd,
          acceptOrderKey: row.acceptOrderKey,
          docName: row.docName,
          docId: row.docId,
          reportId: file?.reportId,
          reqDocId: file?.reqDocId,
          requestDetailId: row?.requestDetailId,
        }

        try {
          this.$baseColorfullLoading()
          let res = await request({
            url: row.deleteUrl,
            method: 'post',
            data,
          })
          if (!res) {
            this.msgSuccess(
              this.$t(`validateMessage.${this.$messageCode.I00000414.name}`)
            )
            item.fileList.splice(index, 1)
            if (item.fileList.length == 0) {
              row.list = []
            }
            this.$set(this.fileList, 'list', row.list)
            this.vm.delFileListById(file)
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      // ファイルを削除
      deleteFile(row, file, item, index) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'OK',
          yes: () => {
            this.submitDelFile(row, file, item, index)
          },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mark {
    margin-left: 5px;
  }
  .state_box_grey {
    background: #f7f7f7;
    border: 1px solid #848484;
    margin-left: 12px;
    padding: 6px;
    color: #848484;
  }
  .state_box_red {
    background: #fff6f6;
    border: 1px solid #c90022;
    margin-left: 12px;
    padding: 6px;
    color: #c90022;
  }
  .state_box_blue {
    background: #ecf5ff;
    border: 1px solid #0060c2;
    margin-left: 12px;
    padding: 6px;
    color: #0060c2;
  }
</style>
